import { Component } from '@angular/core';

@Component({
  selector: 'app-cktech-footer',
  templateUrl: './cktech-footer.component.html',
  styleUrl: './cktech-footer.component.scss'
})
export class CktechFooterComponent {
currentYear = new Date().getFullYear();
}
